// locales utils
export const getMainLanguage = languagesString => {
  return languagesString.split(',')[0]
}

export const getListWithNewMainLanguage = (value, list = null) => {
  if (!value || !list) throw new Error('setMainLanguage utility: list or value is not provided')
  const valueIndex = list.findIndex(listItem => listItem === value)
  if (valueIndex === 0) return list.join(',')
  // remove old value
  list.splice(valueIndex, 1)
  // set new value to begin
  list.unshift(value)
  return list.join(',')
}

export const setTranslation = (data, language) => {
  data.translations[getMainLanguage(language)] = {
    isEnabled: true
  }
  // if (data.translations[getMainLanguage(language)] === null) {
  // }
}
